import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import useSpinner from '../../context/hooks/useSpinner'
import styles from './TenderSelectLoader.module.scss'
import VNLoader from '../../VNLoader/components/VNLoader'
import { setRoute } from '../../VNRoutes/ActionCreators'

/**
 * TenderSelectLoader component for tabs "Pay Now" payment flow
 *   using routing as a buffer to prevent any pending cart update to
 *   happen after totals call
 *
 * @returns React.Element
 */
const TenderSelectLoader = () => {
  const dispatch = useDispatch()
  const { showSpinner, stopSpinner } = useSpinner()

  useEffect(() => {
    if (showSpinner) {
      dispatch(setRoute('/tender-selection'))
      stopSpinner()
      return
    }

    dispatch(setRoute('/concession-order'))

    return () => {
      stopSpinner()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className={styles.container}>
      <VNLoader transparent />
    </div>
  )
}

export default TenderSelectLoader
